import { BaseApiService } from "./base";

const API_ENDPOINT = "/api/v4/advisory_services";

export class AdvisoryServicesApiService extends BaseApiService implements AdvisoryServicesApi.Service {
  public getAll: AdvisoryServicesApi.GetAllFn = () => this.axios.get(`${API_ENDPOINT}`);
}
